export default function Hero() {
  const stats = [
    { value: '12,000+', label: '影视资源' },
    { value: '24h', label: '极速更新' },
    { value: '1080P', label: '高清画质' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden bg-background-950"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20movie%20theater%20atmosphere%20with%20warm%20red%20and%20gold%20accents%2C%20abstract%20film%20reel%20textures%2C%20dramatic%20lighting%20with%20soft%20bokeh%20effects%2C%20luxurious%20velvet%20curtain%20textures%2C%20elegant%20cinema%20vibe%2C%20rich%20dark%20background%20with%20subtle%20gradients%2C%20premium%20entertainment%20aesthetic&width=1920&height=1080&seq=hero-bg-2026-dsxy&orientation=landscape"
          alt="大师兄影视 - 沉浸式观影体验"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tagline */}
            <div className="inline-flex items-center gap-2 bg-primary-500/20 border border-primary-500/30 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-sm font-medium text-primary-300 whitespace-nowrap">新片速递 · 每日更新</span>
            </div>

            {/* H1 */}
            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white leading-tight mb-5">
              大师兄影视
              <br className="md:hidden" />
              <span className="text-primary-400"> — 你的私人观影管家</span>
            </h1>

            {/* Slogan */}
            <p className="text-lg md:text-xl text-white/60 font-heading mb-6">
              最新上映 · 热播推荐 · 更新快抢先看
            </p>

            {/* Description */}
            <p className="text-sm md:text-base text-white/50 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              大师兄影视第一时间更新最新上映电影、热播电视剧和热门综艺节目，片源覆盖全球各大平台与院线。
              每天不间断更新，确保你以最快速度看到想追的每一部作品。无论是院线大片、平台独播剧还是经典怀旧，
              这里全部高清免费在线观看不卡顿，全集播放一网打尽。
            </p>

            {/* Stats */}
            <div className="flex items-center justify-center lg:justify-start gap-8 md:gap-12 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-white font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/40 mt-1 whitespace-nowrap">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm shadow-lg shadow-primary-500/25"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜单
              </a>
              <a
                href="#topics"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 text-white font-medium px-8 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line text-lg"></i>
                浏览热门话题
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px] hidden lg:block">
            <div className="relative">
              {/* Featured visual card */}
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/40 aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20composition%20with%20dramatic%20lighting%2C%20film%20strip%20elements%2C%20golden%20spotlight%20effects%2C%20elegant%20dark%20background%20with%20warm%20red%20and%20amber%20highlights%2C%20premium%20cinema%20aesthetic%2C%20luxurious%20texture%2C%20artistic%20film%20photography%20style&width=800&height=1000&seq=hero-visual-dsxy-01&orientation=portrait"
                  alt="大师兄影视 - 热门影视推荐"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block bg-primary-500 text-white text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
                    本周必看
                  </span>
                  <h3 className="text-white font-heading font-bold text-xl mb-1">暑期档热映中</h3>
                  <p className="text-white/60 text-sm">每日更新 · 片源齐全</p>
                </div>
              </div>

              {/* Floating card */}
              <div className="absolute -top-4 -right-4 bg-background-50 rounded-xl p-3 shadow-lg shadow-black/20 hidden xl:block">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center">
                    <i className="ri-thumb-up-line text-white text-sm"></i>
                  </div>
                  <div>
                    <div className="text-xs font-semibold text-foreground-950 whitespace-nowrap">98% 好评</div>
                    <div className="text-[10px] text-foreground-500 whitespace-nowrap">来自观众反馈</div>
                  </div>
                </div>
              </div>

              {/* Floating badge */}
              <div className="absolute -bottom-3 -left-3 bg-accent-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg shadow-accent-500/30 hidden xl:flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-flashlight-line"></i>
                极速播放不卡顿
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/30">
        <span className="text-[10px] uppercase tracking-wider whitespace-nowrap">向下探索</span>
        <i className="ri-arrow-down-line animate-bounce text-sm"></i>
      </div>
    </section>
  );
}